import type { CoursesAdminSaveEventDefDto, CoursesTrackEventDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	TrackCustomEventInput,
	TrackCustomEventOutput,
	ListActiveEventDefsOutput,
	AdminListEventDefsOutput,
	AdminSaveEventDefInput,
	AdminSaveEventDefOutput,
	AdminDeleteEventDefInput,
	AdminDeleteEventDefOutput,
} from '../../types/analytics-events.types';

const TAG = 'courses:analytics-events' as const;
const INVALIDATES = [TAG] as const;

export const analyticsEventsEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		trackCustomEvent: builder.mutation<TrackCustomEventOutput, TrackCustomEventInput>({
			query: (body) => ({
				url: 'courses/analytics-events/track',
				method: 'POST',
				body: body satisfies Wire<CoursesTrackEventDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		listActiveEventDefs: builder.query<ListActiveEventDefsOutput, void>({
			query: () => ({ url: 'courses/analytics-events/defs' }),
			providesTags: [TAG],
		}),
		adminListEventDefs: builder.query<AdminListEventDefsOutput, void>({
			query: () => ({ url: 'courses/admin/platform/event-defs' }),
			providesTags: [TAG],
		}),
		adminSaveEventDef: builder.mutation<AdminSaveEventDefOutput, AdminSaveEventDefInput>({
			query: (body) => ({
				url: 'courses/admin/platform/event-defs',
				method: 'POST',
				body: body satisfies Wire<CoursesAdminSaveEventDefDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		adminDeleteEventDef: builder.mutation<AdminDeleteEventDefOutput, AdminDeleteEventDefInput>({
			query: ({ id }) => ({
				url: `courses/admin/platform/event-defs/${encodeURIComponent(id)}`,
				method: 'DELETE',
			}),
			invalidatesTags: [...INVALIDATES],
		}),
	}),
});

export const {
	useTrackCustomEventMutation,
	useListActiveEventDefsQuery,
	useLazyListActiveEventDefsQuery,
	useAdminListEventDefsQuery,
	useLazyAdminListEventDefsQuery,
	useAdminSaveEventDefMutation,
	useAdminDeleteEventDefMutation,
} = analyticsEventsEndpoints;
